import CustomButton from "components/button/custom_button";
import Card from "components/card";
import InputField from "components/fields/InputField";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApiList from "services/apiList";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
const Times = () => {
  const navigate = useNavigate();
  var user = useSelector(currentUser);
  const [isEdit, setIsEdit] = useState(false);
  const [values, setValues] = useState({
    lesson_duration: "40",
    small_break: "5",
    big_break: "10",
    big_break_queue: "3",
  });
  const inputs = [
    {
      id: "t1",
      name: "lesson_duration",
      type: "number",
      min: "20",
      max: "120",
      placeholder: "e.g. 40 минут",
      errorMessage: "Хичээлийн үргэлжлэх хугацаа оруулна уу",
      label: "Хичээлийн үргэлжлэх хугацаа (минутаар)",
      required: true,
    },
    {
      id: "t2",
      name: "small_break",
      type: "number",
      min: "1",
      max: "20",
      placeholder: "e.g. 5 минут",
      errorMessage: "Бага завсарлага оруулна уу",
      label: "Бага завсарлага (минутаар)",
      required: true,
    },
    {
      id: "t3",
      name: "big_break",
      type: "number",
      min: "3",
      max: "80",
      placeholder: "e.g. 10 минут",
      errorMessage: "Их завсарлага оруулна уу",
      label: "Их завсарлага (минутаар)",
      required: true,
    },
    {
      id: "t4",
      name: "big_break_queue",
      type: "number",
      min: "1",
      max: "10",
      placeholder: "e.g. 3",
      errorMessage: "Их завсарлагын дараалал оруулна уу",
      label: "Их завсарлагын дараалал",
      required: true,
    },
  ];

  const mount = useRef(true);
  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      const token = user.token;
      const es = new ESService(token);
      es.get(ApiList.timeUrl).then((json) => {
        if (json["status"]) {
          if (json["data"]["lesson_duration"] !== null) {
            setValues(json["data"]);
            setIsEdit(true);
          }
        }
      });
    }
  }, [user]);

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);
      const data = {
        lesson_duration: values["lesson_duration"],
        small_break: values["small_break"],
        big_break: values["big_break"],
        big_break_queue: values["big_break_queue"],
      };
      if (isEdit) {
        es.put(ApiList.timeUrl + values["id"] + "/", data).then((json) => {
          if (json["status"]) {
            navigate("/admin/settings");
          }
        });
      } else {
        es.post(ApiList.timeUrl, data).then((json) => {
          if (json["status"]) {
            navigate("/admin/settings");
          }
        });
      }
    }
  };
  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
        <form onSubmit={handleSubmit}>
          {inputs.map((input, index) => (
            <InputField
              key={"key" + input.id}
              id={input.id}
              className="lg:w-96"
              {...input}
              value={values[input.name]}
              onChange={onChange}
            />
          ))}
          <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          <CustomButton
            onClick={() => {
              navigate("/admin/settings");
            }}
            text="Буцах"
            isBack={true}
          />
        </form>
      </div>
    </Card>
  );
};

export default Times;
